import request from '../request';
export default {
  namespaced: true,
  state: {
    loading: false,
    order: {},
    status: 'available',
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setOrder(state, order) {
      state.order = order;
    },
    setStatus(state, status) {
      state.status = status;
    },
  },
  actions: {
    getOrder(context, { id }) {
      return new Promise((resolve) => {
        const { app } = context.rootState;
        context.commit('setLoading', true);
        request.make(
          {
            type: 'GET',
            url: `${app.API_URL}${context.rootState.language}/${app.endpoints.ORDER_REVIEW}?id=${id}`,
          },
          (err, res) => {
            context.commit('setLoading', false);
            if (res.status === 200) {
              if (typeof res.body !== 'undefined') {
                context.commit('setOrder', res.body);
                context.commit('setStatus', 'available');
                resolve();
              }
            }
            if (res.status === 406) {
              context.commit('setOrder', {});
              context.commit('setStatus', 'notAvailable');
            }
          }
        );
      });
    },
  },
};
